var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('details',{staticClass:"disclosure",attrs:{"open":_vm.open}},[_c('summary',[_c('span',{staticClass:"label"},[_vm._t("label")],2),_c('i',{staticClass:"bdg-icon caret-right"})]),_c('div',{staticClass:"content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }